import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig, providersCasino, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the filter deposit reports view.
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            // Left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Datepicker input field
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
                {
                    view: 'datepicker', // Datepicker component
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    value: moment().format('YYYY-MM-DD'), // Default date value
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum selectable date
                        },
                    },
                },
            ],
        };
        const center_left = {
            // Center left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting type
                    name: 'Type',
                    localId: 'provider:combo',
                    label: _('Tipo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [
                        { id: '0', value: _('Mensual') }, // Monthly option
                        { id: '1', value: _('Diario') }, // Daily option
                    ],
                },
            ],
        };
        const transactionId = {
            // Section for transaction ID input
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Input field for transaction ID
                    name: 'TransactionId',
                    type: 'number',
                    label: _('Transacción ID'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Transacción ID'), // Localized placeholder
                    invalidMessage: _('Transacción ID is required'), // Validation message
                },
            ],
        };
        const center_right = {
            // Center right section (currently empty)
            margin: 5,
            minWidth: 200,
            rows: [],
        };
        const upper_section = {
            // Upper section containing the form fields
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right], // Layout of columns
                },
            ],
        };
        const buttons = {
            // Button section for actions
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Localized label
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('b5').collapse(); // Collapse the accordion
                    },
                },
            ],
        };
        const buttons2 = {
            // Second button section for actions
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'), // Localized label
                    width: 100,
                    click: () => {
                        $$('myForm2').clear(); // Clears the second form
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Trigger filter event with second form data
                        ]);
                    },
                },
            ],
        };
        const accordion_section = {
            // Accordion section for filters
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            // Second accordion section
            padding: 10,
            rows: [upper_section, buttons2], // Contains upper section and second set of buttons
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3], // Contains the second accordion section
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            // Main return object for the view
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Fallback for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }
    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if condition is true
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
